<template>
  <v-container fluid>
    <v-row dense>
      <v-col class="d-flex justify-start" cols="4" sm="4" md="1" lg="1" xl="1">
        <v-btn color="grey" small class="black--text" @click="toBack">前の日へ</v-btn>
      </v-col>
      <v-col class="d-flex justify-center" cols="4" sm="4" md="1" lg="1" xl="1">
        <v-btn color="grey" small class="black--text" @click="calendar">日付選択</v-btn>
      </v-col>
      <v-col class="hidden-md-and-up" style="text-align:right" cols="4" sm="4">
        <v-btn color="grey" small class="black--text" @click="toForward">次の日へ</v-btn>
      </v-col>
      <v-col cols="12" sm="12" md="8" lg="8" xl="8">
        <Datepicker
          ref="picker"
          :monday-first="true"
          wrapper-class="calender-text-box-wrapper"
          input-class="calender-text-box"
          placeholder=""
          :language="dataPickLang"
          @selected=dateSelected />
        <v-card class="mx-auto text-center black--text" outlined>
          <div align="center">
            {{ groupName }}の出欠早退状況({{ yyyymmddDisp }})
          </div>
        </v-card>
      </v-col>
      <v-col class="hidden-sm-and-down" style="text-align:right" md="2" lg="2" xl="2">
        <v-btn color="grey" small class="black--text" @click="toForward">次の日へ</v-btn>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="6" sm="6" md="6" lg="6" xl="6">
        <!-- 検索用のテキスト入力 -->
        <v-text-field
          v-model="search"
          label="氏名ｶﾅ検索"
          placeholder="氏名ｶﾅ検索"
          outlined
          dense
          hide-details="auto"
          background-color="white"
        ></v-text-field>
      </v-col>
      <v-col cols="6" sm="6" md="6" lg="6" xl="6">
        <v-radio-group
          v-model="viewChange"
          row
          hide-details="auto"
        >
          <v-radio
            label="通常"
            value="1"
          ></v-radio>
          <v-radio
            label="パスワード初期化"
            value="2"
          ></v-radio>
        </v-radio-group>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" justify="center">
        <v-data-table
          :headers="showHeaders"
          :items="members"
          :items-per-page.sync="perPage"
          :footer-props="{'items-per-page-options': [10, 20, 30, 50, 100, -1]}"
          :loading="isListLoding" loading-text="読込中"
          :search="search"
          :custom-filter="filter"
          >

          <template #[`header.userNm`]="{}"> 
            <v-row dense><v-col cols="12" justify="center">
              氏名(ｶﾅ)
            </v-col></v-row>
            <v-row dense><v-col cols="12" justify="center">
              課程/部/科/学年/学級/出席番号
            </v-col></v-row>
          </template>

          <template #[`item.userNm`]="{ item }">
            <v-row dense><v-col cols="12" justify="center">
              {{ item.userNm }}({{ item.userNmKana }})  
            </v-col></v-row>
            <v-row dense><v-col cols="12" justify="center">
              {{ item.kateiNm }}/{{ item.buNm }}/{{ item.kaNm }}/{{ item.gakunen }}/{{ item.gakkyu }}/{{ item.syussekiNo }}
            </v-col></v-row>
          </template>

          <template #[`item.action`]="{ item }">
            <v-row dense>
              <v-col cols="4" justify="center" style="font-size:0.8em">
                集計
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="blue" icon outlined v-bind="attrs" v-on="on" @click="viewAttendanceSummaryForStudent(item)"><v-icon small>mdi-information-outline</v-icon></v-btn>
                  </template>
                  <span>生徒の今年度の出欠状況集計</span>
                </v-tooltip>
              </v-col>
              <v-col cols="4" justify="center" style="font-size:0.8em">
                保護者
                <v-tooltip bottom v-if="!item.existsParentRoomFlg">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="accent" icon outlined v-bind="attrs" v-on="on" @click="onClickTalkRoomDialogToParent(item)">
                      <v-icon small>mdi-chat-plus</v-icon>
                    </v-btn>
                  </template>
                  <span>保護者へ個別連絡</span>
                </v-tooltip>
                <v-tooltip bottom v-if="item.existsParentRoomFlg">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="green" icon outlined v-bind="attrs" v-on="on" @click="moveTalkRoomToParent(item)">
                      <v-icon small>mdi-forum-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>作成済の保護者との個別連絡へ移動します。</span>
                </v-tooltip>
              </v-col>
              <v-col cols="4" justify="center" style="font-size:0.8em">
                生徒
                <v-tooltip bottom v-if="!item.existsStudentRoomFlg">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="accent" icon outlined v-bind="attrs" v-on="on" @click="onClickTalkRoomDialogToStudent(item)">
                      <v-icon small>mdi-chat-plus</v-icon>
                    </v-btn>
                  </template>
                  <span>生徒へ個別連絡</span>
                </v-tooltip>
                <v-tooltip bottom v-if="item.existsStudentRoomFlg">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="green" icon outlined v-bind="attrs" v-on="on" @click="moveTalkRoomToStudent(item)">
                      <v-icon small>mdi-forum-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>作成済の生徒との個別連絡へ移動します。</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </template>

          <!-- 出欠 -->
          <template #[`item.syukketu`]="{ item }">
            <v-row dense>
              <v-col cols="3" justify="center">
                <div>{{ item.syukketuKbnNm }}</div>
                <div class="red--text" v-if="item.syukketuInputFlg == true && item.syukketuApprovalFlg == false">{{ item.syukketuApprovalKbnNm }}</div>
                <div v-else>{{ item.syukketuApprovalKbnNm }}</div>
              </v-col>
              <v-col cols="9" justify="center" class="d-flex">
                <v-btn color="accent" small class="black--text mt-2" :disabled="item.pastLockFlg" @click="onClickSyukketu(item)">出欠登録</v-btn>
                <v-btn color="accent" small class="black--text mt-2 ml-2" :disabled="pastLock(item, true)" @click="onClickSyukketuApproval(item)">出欠確定</v-btn>  
              </v-col>
            </v-row>
          </template>
          <!-- 出欠 -->
          <template #[`item.sotai`]="{ item }">
            <v-row dense>
              <v-col cols="3" justify="center">
                <div>{{ item.sotaiKbnNm }}</div>
                <div class="red--text" v-if="item.sotaiInputFlg == true && item.sotaiApprovalFlg == false">
                  {{ item.sotaiApprovalKbnNm }}
                </div>
                <div v-else>{{ item.sotaiApprovalKbnNm }}</div>
              </v-col>
              <v-col cols="9" justify="center" class="d-flex">
                <v-btn color="blue" small class="black--text mt-2" :disabled="item.pastLockFlg" @click="onClickSoutai(item)">早退登録</v-btn>
                <v-btn color="blue" small class="black--text mt-2 ml-2" :disabled="pastLock(item, false)" @click="onClickSoutaiApproval(item)">早退確定</v-btn>
              </v-col>
            </v-row>
          </template>
          <!-- カレンダー登録 -->
          <template #[`item.action2`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="green" icon outlined v-bind="attrs" v-on="on" :disabled="item.calendarLockFlg" @click="onClickCalendarEditer(item)"><v-icon small>mdi-calendar-edit-outline</v-icon></v-btn>
              </template>
              <span>出欠と早退をカレンダーから登録する</span>
            </v-tooltip>
          </template>

          <!-- パスワード初期化 -->
          <!-- 生徒初回ログイン -->
          <template #[`item.consentFlg`]="{ item }">
            <span v-if="item.consentFlg">済</span>
            <span v-else class="red--text">未</span>
          </template>
          <!-- 保護者初回ログイン -->
          <template #[`item.parentConsentFlg`]="{ item }">
            <span v-if="item.parentConsentFlg">済</span>
            <span v-else class="red--text">未</span>
          </template>
          <!-- メールアドレス設定状況 -->
          <template #[`item.mailAddressAuthFlg`]="{ item }">
            <v-row no-gutters>
              <v-col cols="12" class="text-caption">
                生徒１：{{ item.mailAddress }}
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12" class="text-caption">
                生徒２：{{ item.mailAddress2 }}
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12" class="text-caption">
                保護者１：{{ item.parentMailAddress }}
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12" class="text-caption">
                保護者２：{{ item.parentMailAddress2 }}
              </v-col>
            </v-row>
          </template>
          <!-- パスワード変更状況 -->
          <template #[`item.passwordChangeFlg`]="{ item }">
            <v-row no-gutters>
              <v-col cols="12" class="text-caption">
                生徒：<span v-if="item.passwordChangeFlg">済</span>
                      <span v-else class="red--text">未</span>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12" class="text-caption">
                保護者：<span v-if="item.parentPasswordChangeFlg">済</span>
                      <span v-else class="red--text">未</span>
              </v-col>
            </v-row>
          </template>
          <template #[`item.action5`]="{ item }">
            <v-btn color="blue" small class="black--text" @click="onClickResetDialog(item)">パスワード初期化</v-btn>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <!-- 戻るボタン -->
    <v-row class="justify-start" dense>
      <v-col>
        <v-btn @click="onClicktoGroupSelect" color="grey" class="black--text" width="352">戻る</v-btn>
      </v-col>
    </v-row>

    <!-- 再読み込みボタン -->
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" fixed fab bottom color="secondary" @click="reload" style="bottom: 50px">
          <v-icon color="white">mdi-refresh</v-icon>
        </v-btn>
      </template>
      <span>再読込</span>
    </v-tooltip>

    <!-- その他モーダル類 start ********************************************************************************************** -->
    <!-- 個人単位出欠集計(今年度月別)モーダル -->
    <v-dialog
      v-model="summaryDialog"
      max-width="1200"
    >
      <v-card>
        <v-card-title class="pl-5" style="font-size:1.012rem;">個人単位出欠集計(今年度月別) 生徒氏名：{{ summaryStudentName }}</v-card-title>
        <v-card-actions>
          <v-select
            label="表示制御"
            class="mt-1"
            :items="viewKbnList"
            item-text="text"
            item-value="value"
            v-model="viewKbn"
            outlined
            dense
            hide-details="auto"
            background-color="white"
          ></v-select>
        </v-card-actions>
        <v-card-text>
          <v-data-table
            :headers="summaryHeader"
            :items="summaryList"
            :items-per-page="-1"
            dense
            disable-sort
            hide-default-footer
          >
            <template #[`item.dataView`]="{ item }">
              <v-row no-gutters style="background-color: #F5F5F5" v-if="viewKbn == '2' || viewKbn == '3'">
                <v-col cols="2" class="justify-start">
                  出欠
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon class="ml-2" v-bind="attrs" v-on="on" color="grey">mdi-help-circle-outline</v-icon>
                    </template>
                    <div>保護者もしくは教員により出欠登録された</div>
                    <div>区分を集計しています</div>
                  </v-tooltip>
                </v-col>
                <v-col cols="2" class="justify-start">
                  <span v-if="item.unconfirmedKesseki > 0" class="font-weight-bold">欠席: {{ item.unconfirmedKesseki }}</span>
                  <span v-else>欠席: 0</span>
                </v-col>
                <v-col cols="2" class="justify-start">

                </v-col>
                <v-col cols="2" class="justify-start">

                </v-col>
                <v-col cols="2" class="justify-start">
                  <span v-if="item.unconfirmedChikoku > 0" class="font-weight-bold">遅刻: {{ item.unconfirmedChikoku }}</span>
                  <span v-else>遅刻: 0</span>
                </v-col>
                <v-col cols="2" class="justify-start">
                  <span v-if="item.unconfirmedSotai > 0" class="font-weight-bold">早退: {{ item.unconfirmedSotai }}</span>
                  <span v-else>早退: 0</span>
                </v-col>
              </v-row>
              <v-row no-gutters v-if="viewKbn == '1' || viewKbn == '3'">
                <v-col cols="2" class="justify-start">
                  確定
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon class="ml-2" v-bind="attrs" v-on="on" color="grey">mdi-help-circle-outline</v-icon>
                    </template>
                    <div>出欠登録に対して確定登録された</div>
                    <div>区分を集計しています</div>
                  </v-tooltip>
                </v-col>
                <v-col cols="2" class="justify-start">
                  <span v-if="item.confirmedKesseki > 0" class="font-weight-bold">欠席: {{ item.confirmedKesseki }}</span>
                  <span v-else>欠席: 0</span>
                </v-col>
                <v-col cols="2" class="justify-start">
                  <span v-if="item.confirmedSyuttei > 0" class="font-weight-bold">出停: {{ item.confirmedSyuttei }}</span>
                  <span v-else>出停: 0</span>
                </v-col>
                <v-col cols="2" class="justify-start">
                  <span v-if="item.confirmedKibiki > 0" class="font-weight-bold">忌引: {{ item.confirmedKibiki }}</span>
                  <span v-else>忌引: 0</span>
                </v-col>
                <v-col cols="2" class="justify-start">
                  <span v-if="item.confirmedChikoku > 0" class="font-weight-bold">遅刻 :{{ item.confirmedChikoku }}</span>
                  <span v-else>遅刻: 0</span>
                </v-col>
                <v-col cols="2" class="justify-start">
                  <span v-if="item.confirmedSotai > 0" class="font-weight-bold">早退: {{ item.confirmedSotai }}</span>
                  <span v-else>早退: 0</span>
                </v-col>
              </v-row>
            </template>
            <!-- 未確認の有無表示 -->
            <template #[`item.unconfirmedFlg`]="{ item }">
              <span v-if="item.unconfirmedFlg" class="font-weight-bold red--text">あり</span>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- 個別連絡作成モーダル -->
    <v-dialog
      v-model="talkRoomDialog"
      max-width="800"
      persistent
    >
      <ValidationObserver ref="obs" v-slot="{ invalid }">
        <v-card
          class="d-flex justify-center flex-column mx-auto flat"
          width="800"
          color="#fff"
        >
          <v-card-subtitle class="d-flex justify-center" white-space="pre">
            <v-row dense>
              <v-col dense cols="2" justify="center">
                <v-btn color="grey" class="black--text" @click="talkRoomDialog = false" width="90%">
                  閉じる
                </v-btn>
              </v-col>
              <v-col dense cols="8" justify="center">
                <span>{{ talkRoomStudentNm }}</span>
                <span v-if="talkRoomToParentFlg == true">の保護者</span>
                <span>との個別連絡を作成</span>
              </v-col>
              <v-col dense cols="2" justify="center">
                <v-btn v-if="talkRoomToParentFlg == true" color="accent" class="black--text" @click="openTalkRoomToParent()" :disabled="invalid" width="90%">
                  作成
                </v-btn>
                <v-btn v-if="talkRoomToParentFlg == false" color="accent" class="black--text" @click="openTalkRoomToStudent()" :disabled="invalid" width="90%">
                  作成
                </v-btn>
              </v-col>
            </v-row>
          </v-card-subtitle>
          <v-card-text class="d-flex justify-center flex-column">
            <v-row dense>
              <v-col dense cols="12" justify="center">
                <v-autocomplete
                  v-model="talkRoomAssign"
                  label="やりとりに参加する教員(自身以外)"
                  placeholder="やりとりに参加する教員(自身以外)"
                  :items="teacherList"
                  outlined
                  dense
                  multiple
                  deletable-chips
                  small-chips
                  clearable
                  hide-details="auto"
                  background-color="white"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </ValidationObserver>
    </v-dialog>
    <!-- その他モーダル類 end ********************************************************************************************** -->

    <!-- 出欠修正ダイアログ -->
    <v-dialog
      v-model="syukketuDialog"
      max-width="500"
      min-height="490"
      max-height="490"
      persistent
      eager
      scrollable
    >
      <v-card
        class="d-flex flex-column mx-auto my-auto flat"
        color="#fff"
        min-height="490"
      >
        <v-card-actions class="my-0">
          <v-row dense>
            <v-col cols="2" justify="center">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn small v-bind="attrs" v-on="on" color="grey" @click="syukketuDialog = false">
                    <v-icon color="white">mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>閉じる</span>
              </v-tooltip>
            </v-col>
            <v-col cols="8" class="d-flex justify-center">
              出欠登録({{ targetStudentNm }})
            </v-col>
            <v-col cols="2" justify="center">
            </v-col>
          </v-row>
        </v-card-actions>
        <AttendanceEdit
          v-if="syukketuDialog"
          :studentId=targetStudentId
          :param_yyyymmdd=yyyymmdd
          @changeSyukketu="changeSyukketu"
        />
      </v-card>
    </v-dialog>

    <!-- 出欠確定モーダル -->
    <v-dialog
      v-model="attendanceApprovalDialog"
      max-width="500"
      min-height="260"
      max-height="260"
      persistent
      eager
      scrollable
    >
      <v-card
        class="d-flex flex-column mx-auto my-auto flat"
        color="#fff"
        min-height="260"
      >
        <v-card-actions class="my-0">
          <v-row dense>
            <v-col cols="2" justify="center">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn small v-bind="attrs" v-on="on" color="grey" @click="attendanceApprovalDialog = false">
                    <v-icon color="white">mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>閉じる</span>
              </v-tooltip>
            </v-col>
            <v-col cols="8" class="d-flex justify-center">
              出欠確定({{ targetStudentNm }})
            </v-col>
            <v-col cols="2" justify="center">
            </v-col>
          </v-row>
        </v-card-actions>
        <AttendanceApproval
          v-if="attendanceApprovalDialog"
          :studentId=targetStudentId
          :param_yyyymmdd=yyyymmdd
          @changeSyukketuApproval="changeSyukketuApproval"
        />
      </v-card>
    </v-dialog>

    <!-- 早退登録ダイアログ -->
    <v-dialog
      v-model="sotaiDialog"
      max-width="500"
      min-height="490"
      max-height="490"
      persistent
      eager
      scrollable
    >
      <v-card
        class="d-flex flex-column mx-auto my-auto flat"
        color="#fff"
        min-height="490"
      >
        <v-card-actions class="my-0">
          <v-row dense>
            <v-col cols="2" justify="center">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn small v-bind="attrs" v-on="on" color="grey" @click="sotaiDialog = false">
                    <v-icon color="white">mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>閉じる</span>
              </v-tooltip>
            </v-col>
            <v-col cols="8" class="d-flex justify-center">
              早退登録({{ targetStudentNm }})
            </v-col>
            <v-col cols="2" justify="center">
            </v-col>
          </v-row>
        </v-card-actions>
        <LeavingRegist
          v-if="sotaiDialog"
          :studentId=targetStudentId
          :parentMailAuthFlg=sotaiParentMailAuthFlg
          :param_yyyymmdd=yyyymmdd
          @changeSotai="changeSotai"
        />
      </v-card>
    </v-dialog>

    <!-- 早退確定モーダル -->
    <v-dialog
      v-model="leavingApprovalDialog"
      max-width="500"
      min-height="260"
      max-height="260"
      persistent
      eager
      scrollable
    >
      <v-card
        class="d-flex flex-column mx-auto my-auto flat"
        color="#fff"
        min-height="260"
      >
        <v-card-actions class="my-0">
          <v-row dense>
            <v-col cols="2" justify="center">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn small v-bind="attrs" v-on="on" color="grey" @click="leavingApprovalDialog = false">
                    <v-icon color="white">mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>閉じる</span>
              </v-tooltip>
            </v-col>
            <v-col cols="8" class="d-flex justify-center">
              早退確定({{ targetStudentNm }})
            </v-col>
            <v-col cols="2" justify="center">
            </v-col>
          </v-row>
        </v-card-actions>
        <LeavingApproval
          v-if="leavingApprovalDialog"
          :studentId=targetStudentId
          :param_yyyymmdd=yyyymmdd
          @changeSotaiApproval="changeSotaiApproval"
        />
      </v-card>
    </v-dialog>

    <!-- カレンダー登録モーダル -->
    <v-dialog
      v-model="calendarEditerDialog"
      max-width="1000"
      min-height="260"
      max-height="260"
      persistent
      eager
      scrollable
    >
      <v-card
        class="d-flex flex-column mx-auto my-auto flat"
        color="#fff"
        min-height="260"
      >
        <v-card-actions class="my-0">
          <v-row dense>
            <v-col cols="2" justify="center">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn small v-bind="attrs" v-on="on" color="grey" @click="calendarEditerDialog = false">
                    <v-icon color="white">mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>閉じる</span>
              </v-tooltip>
            </v-col>
            <v-col cols="8" class="d-flex justify-center">
              カレンダー登録({{ targetStudentNm }})
            </v-col>
            <v-col cols="2" justify="center">
            </v-col>
          </v-row>
        </v-card-actions>
        <CalendarEditer
          v-if="calendarEditerDialog"
          :studentId=targetStudentId
          :studentNm=targetStudentNm
          :param_yyyymmdd=yyyymmdd
          @parentReload="reload"
        />
      </v-card>
    </v-dialog>

    <!-- パスワードリセットダイアログ -->
    <v-dialog
      v-model="resetDialog"
      max-width="290"
      persistent
    >
      <v-card>
        <v-card-title class="justify-center">パスワードの初期化</v-card-title>
        <v-card-text>
          初期化された後はアカウント通知書に記載のパスワードとなります
          <v-radio-group v-model="resetType" :mansdatory="false">
            <v-radio label="生徒のパスワード" value="0"></v-radio>
            <v-radio label="保護者のパスワード" value="1"></v-radio>
          </v-radio-group>
          <v-btn block color="accent" @click="doReset()">
            初期化する
          </v-btn>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-row dense>
            <v-col cols="12" justify="center">
              <v-btn block color="grey" @click="resetDialog = false">
                閉じる
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
  
<script>
import { ja as dataPickLang } from 'vuejs-datepicker/dist/locale';
import { httpsCallable, getFunctions } from "firebase/functions";
import { format, parse } from 'date-fns';
import { ja } from 'date-fns/locale';
import AttendanceEdit from './components/AttendanceEdit.vue'
import AttendanceApproval from './components/AttendanceApproval.vue'
import LeavingRegist from './components/LeavingRegist.vue'
import LeavingApproval from './components/LeavingApproval.vue'
import CalendarEditer from './components/CalendarEditer.vue'

export default {
  props: ['groupName','groupId','param_yyyymmdd'],
  watch: {
    yyyymmdd: async function(newVal, oldVal) {
      console.log(newVal, oldVal)
      await this.reload();
    },
    perPage: function(newVal) {
      this.$store.dispatch('setParPageUserList', newVal);
    },
  },
  components: {
    AttendanceEdit,
    AttendanceApproval,
    LeavingRegist,
    LeavingApproval,
    CalendarEditer,
  },
  computed: {
    showHeaders () {
      if(this.viewChange == "1"){
        return this.headers1;
      } else {
        return this.headers2;
      }
    }
  },
  data() {
    return {
      dataPickLang: dataPickLang,
      // 日付選択用
      yyyymmdd: "",
      yyyymmddDisp: "",
      language:{
        language: 'Japanese',
        months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
        monthsAbbr: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
        days: ['日', '月', '火', '水', '木', '金', '土'],
        yearSuffix: '年',
        ymd: true,
      },

      // 明細絞り込み用
      search: "",
      // 明細表示内容制御用
      viewChange: "1",
      headers1: [
        { text: "氏名(ｶﾅ)", value: "userNm", align: "start", width: "240" },
        { text: "操作", value: "action", width: "150" },
        { text: "出欠入力", value: "syukketu", width: "220" },
        { text: "早退入力", value: "sotai", width: "220" },
        { text: "カレンダー入力", value: "action2", width: "110" },
      ],
      headers2: [
        { text: "氏名(ｶﾅ)", value: "userNm", align: "start", width: "240" },
        { text: "生徒初回ログイン", value: "consentFlg", width: "87" },
        { text: "保護者初回ログイン", value: "parentConsentFlg", width: "95" },
        { text: "メール認証状況", value: "mailAddressAuthFlg" },
        { text: "パスワード変更状況", value: "passwordChangeFlg", width: "100" },
        { text: "", value: "action5", width: "165" },
      ],
      members: [],
      isListLoding: false,
      perPage: 30,

      // 個人単位出欠集計
      viewKbn: "3",
      viewKbnList: [
        {value:"3", text:"出欠+確定"},  
        {value:"1", text:"確定のみ"},
        {value:"2", text:"出欠のみ"},
      ],
      summaryDialog: false,
      summaryStudentName: "",
      summaryHeader: [
        { text: "登録月", value: "monthJP"},
        { text: "集計値", value: "dataView"},
        { text: "未確定の有無", value: "unconfirmedFlg", width: "9%" },
      ],
      summaryList: [],

      // 個別連絡作成用
      talkRoomDialog: false,
      talkRoomToParentFlg: false,
      talkRoomStudentId: "",
      talkRoomParentId: "",
      talkRoomStudentNm: "",
      talkRoomAssign: [],
      teacherList: [],

      // 出欠登録確定・早退登録確定 start*************************************************************************
      // 出欠早退確定用
      targetStudentId: "",
      targetStidemtNm: "",

      // 出欠修正用
      syukketuDialog: false,
      attendanceApprovalDialog: false,

      // 早退登録用
      sotaiDialog: false,
      sotaiParentMailAuthFlg: false,

      // 早退確定用
      leavingApprovalDialog: false,

      // カレンダー登録用
      calendarEditerDialog: false,

      // 出欠登録確定・早退登録確定 end*************************************************************************

      // パスワードリセット用
      resetUserId: "",
      resetType: "0",
      resetDialog: false,
    };
  },
  // 初期表示時データ読み込み
  async created() {
    // グループ未選択は選択画面へ
    if(!this.groupId){
      this.onClicktoGroupSelect();
    }
    this.perPage = this.$store.state.parPageUserList;
    var date = parse(this.param_yyyymmdd, 'yyyy-MM-dd', new Date());
    this.yyyymmdd = format(date, 'yyyy-MM-dd', { locale: ja });
    this.yyyymmddDisp = format(date, 'yyyy年M月d日(E)', { locale: ja });

    // 教員リストの取得
    const functions = getFunctions(this.$firebase);
    functions.region = "asia-northeast1";
    const schoolAidHomeLogined = httpsCallable(functions, "schoolAidHomeLogined");
    schoolAidHomeLogined({funcName: "commonGetTeachers", includeFlg: false}).then((ret) => {
      this.teacherList = ret.data.teacherList;
    })
  },
  methods: {
    // ヘッダー処理 start ************************************************************
    // ページ再読込
    async reload() {
      this.members = [];
      console.log("props",this.groupName,this.groupId);
      const data = {
        funcName: "loadUserList",
        groupId: this.groupId,
        yyyymmdd: this.yyyymmdd
      };

      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      const schoolAidHomeLogined = httpsCallable(functions, "schoolAidHomeLogined");
      this.isListLoding = true;
      await schoolAidHomeLogined(data).then((users) => {
        var ret = [];
        users.data.forEach((user) => {
          var row = {
            studentId : user.loginId,
            parentId : user.parentId,
            userNm: user.userNm,
            userNmKana: user.userNmKana,
            kateiNm: user.kateiNm,
            buNm: user.buNm,
            kaNm: user.kaNm,
            gakunen: user.gakunen,
            gakkyu: user.gakkyu,
            syussekiNo: user.syussekiNo,
            consentFlg: user.consentFlg,
            mailAddressAuthFlg: user.mailAddressAuthFlg,
            mailAddress: user.mailAddress,
            mailAddress2: user.mailAddress2,
            passwordChangeFlg: user.passwordChangeFlg,
            parentConsentFlg: user.parentConsentFlg,
            parentMailAuthFlg: user.parentMailAuthFlg,
            parentMailAddress: user.parentMailAddress,
            parentMailAddress2: user.parentMailAddress2,
            parentPasswordChangeFlg: user.parentPasswordChangeFlg,
            // 出欠入力情報
            syukketuInputFlg: user.syukketuInputFlg,
            syukketuKbnNm: user.syukketuKbnNm,
            syukketuApprovalFlg: user.syukketuApprovalFlg,
            syukketuApprovalKbnNm: user.syukketuApprovalKbnNm,

            // 早退入力情報
            sotaiInputFlg: user.sotaiInputFlg,
            sotaiKbnNm: user.sotaiKbnNm,
            sotaiApprovalFlg: user.sotaiApprovalFlg,
            sotaiApprovalKbnNm: user.sotaiApprovalKbnNm,

            groupId : this.groupId,
            pastLockFlg: user.pastLockFlg,
            calendarLockFlg: user.calendarLockFlg,
            existsParentRoomFlg: user.existsParentRoomFlg,
            existsParentRoomId: user.existsParentRoomId,
            existsStudentRoomFlg: user.existsStudentRoomFlg,
            existsStudentRoomId: user.existsStudentRoomId,
          };
          ret.push(row);
        });
        this.isListLoding = false;
        this.members = ret;
      }).catch((e) =>{
        console.log(e.message);
        this.error = e.message;
        this.$root.loading = false;
      });
    },
    // 氏名カナ検索
    filter(value, search, item) {
      if(!item.userNmKana)return false;
      return item.userNmKana.toString().includes(search)
    },
    // データピッカー開閉
    calendar() {
      if(!this.$refs.picker.isOpen) {
          this.$refs.picker.$el.querySelector("input").focus();
          this.$refs.picker.showCalendar();
      } else {
          this.$refs.picker.close();
      }
    },
    // データピッカー日付選択
    dateSelected(selectedDate) {
      this.yyyymmdd = format(selectedDate, 'yyyy-MM-dd', { locale: ja });
      this.yyyymmddDisp = format(selectedDate, 'yyyy年M月d日(E)', { locale: ja });
    },
    // 前の日へボタン
    toBack() {
      var date = parse(this.yyyymmdd, 'yyyy-MM-dd', new Date());
      date.setDate(date.getDate() - 1);
      this.yyyymmdd = format(date, 'yyyy-MM-dd', { locale: ja });
      this.yyyymmddDisp = format(date, 'yyyy年M月d日(E)', { locale: ja });
    },
    // 次の日へボタン
    toForward() {
      var date = parse(this.yyyymmdd, 'yyyy-MM-dd', new Date());
      date.setDate(date.getDate() + 1);
      this.yyyymmdd = format(date, 'yyyy-MM-dd', { locale: ja });
      this.yyyymmddDisp = format(date, 'yyyy年M月d日(E)', { locale: ja });
    },
    // 学期内ボタン制御
    pastLock(item, syukketu){
      var flg = false;
      if (syukketu) {
        // 出欠
        if (item.pastLockFlg) {
          flg = item.pastLockFlg;
        } else {
          flg = item.syukketuInputFlg ? false : true;
        }
      } else {
        // 早退
        if (item.pastLockFlg) {
          flg = item.pastLockFlg;
        } else {
          flg = item.sotaiInputFlg ? false : true;
        }
      }

      return flg;
    },
    // グループ選択に戻る
    onClicktoGroupSelect(){
      this.$router.push({
        name: "GroupSelect"
      });
    },
    // ヘッダー処理 end ************************************************************

    // 通常処理 start ************************************************************
    // 出欠集計(生徒単位月別)モーダル
    async viewAttendanceSummaryForStudent(item) {
      var param = {
        funcName: "viewAttendanceSummaryForStudent",
        studentId: item.studentId,
      }
      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      const schoolAidHomeLogined = httpsCallable(functions,"schoolAidHomeLogined");
      await schoolAidHomeLogined(param).then((ret) => {
        this.summaryList = ret.data;
      });
      this.summaryStudentName = item.userNm;
      this.summaryDialog = true;
    },
    // 個別連絡(保護者宛)
    onClickTalkRoomDialogToParent(item){
      this.talkRoomStudentNm = item.userNm;
      this.talkRoomStudentId = item.studentId;
      this.talkRoomParentId = item.parentId;
      this.talkRoomToParentFlg = true;
      this.talkRoomAssign = [];
      this.talkRoomDialog = true;
    },
    // 個別連絡(生徒宛)
    onClickTalkRoomDialogToStudent(item){
      this.talkRoomStudentNm = item.userNm;
      this.talkRoomStudentId = item.studentId;
      this.talkRoomParentId = "";
      this.talkRoomToParentFlg = false;
      this.talkRoomAssign = [];
      this.talkRoomDialog = true;
    },
    // 個別連絡作成処理(保護者)
    async openTalkRoomToParent(){
      var param = {
        funcName: "openTalkRoomToParent",
        studentId: this.talkRoomStudentId,
        parentId: this.talkRoomParentId,
        assignUserIds: this.talkRoomAssign,
      }
      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      const schoolAidHomeLogined = httpsCallable(functions,"schoolAidHomeLogined");
      await schoolAidHomeLogined(param).then((ret) => {
        if(ret.data.message) {
          alert("作成に失敗しました");
        } else {
          this.$router.push({
            name: "TalkRoom",
            params: {
              roomId: ret.data.roomId,
            }
          });
        }
      });
    },
    // 個別連絡作成処理(生徒)
    async openTalkRoomToStudent(){
      var param = {
        funcName: "openTalkRoomToStudent",
        studentId: this.talkRoomStudentId,
        assignUserIds: this.talkRoomAssign,
      }
      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      const schoolAidHomeLogined = httpsCallable(functions,"schoolAidHomeLogined");
      await schoolAidHomeLogined(param).then((ret) => {
        if(ret.data.message) {
          alert("作成に失敗しました");
        } else {
          this.$router.push({
            name: "TalkRoom",
            params: {
              roomId: ret.data.roomId,
            }
          });
        }
      });
    },
    async moveTalkRoomToStudent(item){
        var result = confirm("生徒との個別連絡へ移動します、よろしいですか？");
        if (!result) {
            return;
        }
        this.$router.push({
            name: "TalkRoom",
            params: {
                roomId: item.existsStudentRoomId,
            }
        });
    },
    async moveTalkRoomToParent(item){
        var result = confirm("保護者との個別連絡へ移動します、よろしいですか？");
        if (!result) {
            return;
        }
        this.$router.push({
            name: "TalkRoom",
            params: {
                roomId: item.existsParentRoomId,
            }
        });
    },
    // 通常処理 end ************************************************************

    // 出欠処理 start ************************************************************
    // 出欠訂正モーダル呼出
    onClickSyukketu(item) {
      this.targetStudentId = item.studentId;
      this.targetStudentNm = item.userNm;
      this.syukketuDialog = true;
    },
    // 出欠訂正モーダルからのフィードバック
    changeSyukketu(uid, syukketuKbn, syukketuKbnNm) {
      console.log("changeSyukketu", uid, syukketuKbn, syukketuKbnNm);
      for(const row of this.members){
        if(row.studentId == uid){
          row.syukketuInputFlg = true;
          row.syukketuKbnNm = (syukketuKbnNm)?syukketuKbnNm:"出席";
        }
      }
      this.syukketuDialog = false;
    },
    // 出欠確定モーダル呼出
    onClickSyukketuApproval(item) {
      this.targetStudentId = item.studentId;
      this.targetStudentNm = item.userNm;
      this.attendanceApprovalDialog = true;
    },
    // 出欠確定モーダルからのフィードバック
    changeSyukketuApproval(uid, approvalFlg, approvalKbnNm) {
      console.log("changeSyukketuApproval", uid, approvalFlg, approvalKbnNm);
      for(const row of this.members){
        if(row.studentId == uid){
          row.syukketuApprovalFlg = approvalFlg;
          row.syukketuApprovalKbnNm = approvalKbnNm;
        }
      }
      this.attendanceApprovalDialog = false;
    },
    // カレンダー登録モーダル呼出
    onClickCalendarEditer(item) {
      this.targetStudentId = item.studentId;
      this.targetStudentNm = item.userNm;
      this.calendarEditerDialog = true;
    },
    // 出欠処理 end ************************************************************

    // 早退処理 start ************************************************************
    // 早退登録モーダル呼出
    onClickSoutai(item) {
      this.targetStudentId = item.studentId;
      this.targetStudentNm = item.userNm;
      this.sotaiParentMailAuthFlg = item.parentMailAuthFlg;
      this.sotaiDialog = true;
    },
    // 早退登録モーダルからのフィードバック
    changeSotai(uid, cancelFlg, sotaiKbnNm) {
      console.log("changeSotai", uid, cancelFlg, sotaiKbnNm);
      for(const row of this.members){
        if(row.studentId == uid){
          row.sotaiInputFlg = true;
          row.sotaiKbnNm = sotaiKbnNm;
        }
      }
      this.sotaiDialog = false;
    },
    // 早退確定モーダル呼出
    onClickSoutaiApproval(item) {
      this.targetStudentId = item.studentId;
      this.targetStudentNm = item.userNm;
      this.leavingApprovalDialog = true;
    },
    // 早退確定モーダルからのフィードバック
    changeSotaiApproval(uid, approvalFlg, approvalKbnNm) {
      console.log("changeSotaiApproval", uid, approvalFlg, approvalKbnNm);
      for(const row of this.members){
        if(row.studentId == uid){
          row.sotaiApprovalFlg = approvalFlg;
          row.sotaiApprovalKbnNm = approvalKbnNm;
        }
      }
      this.leavingApprovalDialog = false;
    },
    // 早退処理 end ************************************************************

    // パスワード初期化処理 start ************************************************************
    // パスワード初期化ダイアログ表示
    onClickResetDialog(item){
      this.resetUserId = item.studentId;
      this.consentFlg = item.consentFlg;
      this.mailAddressAuthFlg = item.mailAddressAuthFlg;
      this.parentConsentFlg = item.parentConsentFlg;
      this.parentMailAuthFlg = item.parentMailAuthFlg;
      this.resetDialog = true;
    },

    // パスワード初期化実行
    async doReset() {
      this.$root.loading = true;
      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      const schoolAidHomeLogined = httpsCallable(functions, "schoolAidHomeLogined");
      const data = {
        funcName: "initPassword",
        resetType: this.resetType,
        studentId: this.resetUserId,
      };
      await schoolAidHomeLogined(data).then((res) => {
        // ローディング非表示
        this.$root.loading = false;
        console.log(res.data);
        alert("パスワードを初期化しました");
        this.reload();
      }).catch((e) => {
        console.log(e.message);
        this.$root.loading = false;
      });
    },
    // パスワード初期化処理 end ************************************************************
  },
};
</script>

<style scoped>
.calender-text-box {
    display: none;
}
.vdp-datepicker__calendar {
    width: 350px !important;
}
</style>